import { render, staticRenderFns } from "./TransferenciaCompraExterna.vue?vue&type=template&id=3bad827e&scoped=true&"
import script from "./TransferenciaCompraExterna.vue?vue&type=script&lang=js&"
export * from "./TransferenciaCompraExterna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad827e",
  null
  
)

export default component.exports